import { Component, OnInit } from '@angular/core';
import { DashboardService, LocalService, SellerPreferencesService } from '../../core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  role: 'manager' | 'seller' = 'seller';
  selectedSellerIds: number[] = [];
  dashboardData: any = null;
  isChallengePreference = false;
  isLoading = false;

  private userData: any;

  constructor(
    private dashboardService: DashboardService,
    private sellerPreferencesService: SellerPreferencesService
  ) {}

  ngOnInit() {
    const stored = localStorage.getItem('selectedRole');
    if (stored === 'manager' || stored === 'seller') {
      this.role = stored;
    }

    this.userData = LocalService.get('userProfile');
    if (this.userData && this.userData.userType === 'PAM') {
      this.role = 'manager';
    }

    this.sellerPreferencesService.getChallengePreference().subscribe(
      (enabled) => { this.isChallengePreference = enabled; }
    );

    this.fetchData();
  }

  onSellerFilterChange(ids: number[]) {
    this.selectedSellerIds = ids;
    this.fetchData();
  }

  private fetchData() {
    this.isLoading = true;
    if (this.role === 'manager') {
      this.dashboardService.getManagerDashboardFull(
        this.userData.company.id, this.selectedSellerIds
      ).subscribe(
        (data: any) => { this.dashboardData = data; this.isLoading = false; },
        () => { this.isLoading = false; }
      );
    } else {
      this.dashboardService.getSellerDashboardFull(this.userData.id, this.userData.company.id).subscribe(
        (data: any) => { this.dashboardData = data; this.isLoading = false; },
        () => { this.isLoading = false; }
      );
    }
  }
}
